import styled from 'styled-components';
import {useTranslation} from 'next-i18next';
import {AnimatePresence, motion} from 'motion/react';
import {LandingBigSecondaryButton} from '../landingStyledComponents';
import CloseIcon from '../../icons/closeIcon.svg';
import TextButton from '../TextButton';

const ButtonShape = styled.img`
  position: absolute;
  top: calc(50% - 52px);
  right: -60px;

  @media (max-width: 700px) {
    display: none;
  }
`;

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 1060px;
  background-color: var(--panelista-dark-color);
  border-radius: 8px;
  color: white;
  padding: 40px;
  margin: -100px 0 80px 0;
  position: relative;

  g {
    stroke: rgba(255, 255, 255, 0.5);
  }

  h3 {
    font-family: var(--font-jakarta);
    font-weight: 700;
    font-size: 28px;
    margin-bottom: 20px;
    margin-right: 40px;
  }

  p {
    color: rgba(255, 255, 255, 0.9);
    max-width: calc(100% - 310px);
  }

  @media (max-width: 700px) {
    padding: var(--side-padding);
    padding-bottom: 30px;
    margin: -80px 0 80px 0;

    p {
      max-width: 100%;
    }
  }
`;

type Props = {
  close: () => void;
  isVisible: boolean;
};

const PanelistaButtonExplainer = ({close, isVisible}: Props) => {
  const {t, i18n} = useTranslation();

  const instructionsUrl =
    i18n.language === 'sv'
      ? 'https://panelista.com/share-widget/6183db02a47b4700167464a8'
      : 'https://panelista.com/share-widget/6183db87a47b470016746530';

  return (
    <AnimatePresence>
      {isVisible ? (
        <Container
          initial={{opacity: 0, y: -40}}
          animate={{opacity: 1, y: 0}}
          exit={{opacity: 0, y: -40, transition: {duration: 0}}}
        >
          <ButtonShape src="/images/panelistaButtonShape.svg" />

          <h3>{t('website.button explainer heading')}</h3>

          <p dangerouslySetInnerHTML={{__html: t('website.button explainer body')}} />

          <LandingBigSecondaryButton
            style={{marginTop: 30, color: 'white', borderColor: 'white'}}
            href={instructionsUrl}
            target="_blank"
          >
            {t('website.see button instructions page')}
          </LandingBigSecondaryButton>

          <TextButton style={{position: 'absolute', top: 10, right: 10}} onClick={close}>
            <CloseIcon />
          </TextButton>
        </Container>
      ) : null}
    </AnimatePresence>
  );
};

export default PanelistaButtonExplainer;
